import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';

const initialState = {
  reports: []
};

const slice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    getReports(state, action) {
      const reports = action.payload;
      state.reports = reports;
    }
  }
});

export const reducer = slice.reducer;

export const getReports = trackId => async dispatch => {
  try {
    const response = await axios.get(`/reports/track/${trackId}`);
    dispatch(slice.actions.getReports(response.data));
  } catch (error) {
    console.log('slices > reports.js > getReports', error);
  }
};

export default slice;
